// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__cFvOT","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3vL9g","obliqueLine":"membershipbadge_obliqueLine__35XhW"};